import "./CommunityPrograms.css";
import "./CommunityProgramsResponsive.css";

import programmesOverview from "../../../assets/data/community-programs/landingpage-programs.json";
import CoreValueItem from "../../../widgets/core-value-item/CoreValueItem";

function CommunityPrograms() {
  return (
    <div className="community-programs">
      <div className="community-programs-overlay"></div>
      <div className="programme-item-header">
        <h1>Our Community Programs</h1>
      </div>
      <div className="row m-0 programme-item-container">
        <div className="row m-0 p-sm-4 d-flex justify-content-center">
          {programmesOverview?.map((item, index) => {
            return <CoreValueItem item={item} key={index} />;
          })}
        </div>
      </div>
    </div>
  );
}

export default CommunityPrograms;
